import { bool, func, shape } from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";

import ContextMenu from "pages/_components/ContextMenu";
import TransactionTicket from "pages/_components/TransactionTicket";
import EcheqAcceptReturnTransactionData from "pages/checks/Echeqs/EcheqTransactions/EcheqAcceptReturnTransactionData";
import { push } from "react-router-redux";
import { selectors } from "reducers/checks";
import { actions as formActions } from "reducers/form";
import { echeqConceptLabel } from "util/checks";
import * as i18n from "util/i18n";
import { exportGenericTicketPdfWithSuccessMessage, getGeneralTicketItem } from "util/transaction";
import { CURRENCY_CODE_COELSA } from "../../../../constants";

const FORM_ID = "echeq.transaction";
class EcheqTransaction extends Component {
    static propTypes = {
        transactionData: shape({}).isRequired,
        dispatch: func.isRequired,
        isDesktop: bool.isRequired,
        isSmallDesktop: bool.isRequired,
        fetching: bool.isRequired,
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        embeddedInV3Shell: false,
    };

    state = {
        showDrawerMobile: false,
        fetchingDownload: false,
    };

    componentDidMount() {
        const { dispatch, transactionData } = this.props;
        if (!transactionData.idTransaction && localStorage.getItem("flow")) {
            dispatch(push(`${JSON.parse(localStorage.getItem("flow"))}`));
        }
    }

    centerContentMobile = () => {
        const { transactionData } = this.props;
        return (
            <div className="title-account-header-multiline-background-blue">
                <h1 style={{ width: "100%", marginTop: "2px" }}>
                    {i18n.get(`activities.${transactionData.idActivity}`)}
                </h1>
            </div>
        );
    };

    summaryDataComponent = () => <EcheqAcceptReturnTransactionData />;

    signTransaction = () => {
        const { dispatch, transactionData } = this.props;

        const signTransactionData = this.summaryDataComponent();

        dispatch(push("/transactions/sign"));
        dispatch(
            formActions.signTransactionData({
                idTransaction: transactionData?.idTransaction,
                idActivity: transactionData.idActivity,
                idForm: "",
                content: signTransactionData,
                title: "activities.accept.return.echeqs",
                pendingDispatch: transactionData?.pendingDispatch,
            }),
        );

        dispatch(
            formActions.signTransactionPreview({
                idActivity: transactionData.idActivity,
                idTransaction: transactionData.idTransaction,
                idForm: "",
                ticketData: transactionData,
            }),
        );
    };

    rightContentTransactionScheme = () => {
        const { isDesktop } = this.props;

        return (
            <ContextMenu
                isDesktop={isDesktop}
                color={!isDesktop ? "white" : undefined}
                buttonClassName="align-self-center account-dropdown-header-font font-black-alpha ml-2"
                items={[
                    {
                        label: "pendingTransaction.info.scheme",
                        onClick: () => this.setState({ showDrawerMobile: true }),
                    },
                ]}
            />
        );
    };

    exportPdf = async () => {
        this.setState({ fetchingDownload: true });
        const { transactionData, dispatch } = this.props;
        const { echeq } = transactionData;

        const ticketData = {
            ticketName: i18n.get(`activities.${transactionData.idActivity}`),
            ticketBody: [
                getGeneralTicketItem(`forms.transaction.ticket.date`, transactionData.submitDateTime, "datefulltime"),
                getGeneralTicketItem(
                    `pay.paymentAFIP.idTransaction`,
                    transactionData?.idTransaction.substring(0, 8).toUpperCase(),
                    "string",
                ),
                getGeneralTicketItem(`${FORM_ID}.echeq.number`, echeq.cheque_numero, "string"),
                getGeneralTicketItem(`${FORM_ID}.echeq.id`, echeq.cheque_id, "string"),
                getGeneralTicketItem(`echeq.request.return.cuit`, echeq.cuit_solic_devol, "string"),
                getGeneralTicketItem(`echeqs.reference.beneficiary`, transactionData.solicitantName, "string"),
                getGeneralTicketItem(
                    `${FORM_ID}.amount`,
                    echeq.monto,
                    echeq?.moneda === CURRENCY_CODE_COELSA ? "amountUSD" : "amountARS",
                ),
                getGeneralTicketItem(`${FORM_ID}.emision`, echeq?.fecha_emision, "date"),
                getGeneralTicketItem(`${FORM_ID}.payed`, echeq?.fecha_pago, "date"),
                getGeneralTicketItem(
                    `${FORM_ID}.echeq.type`,
                    i18n.get(`echeqs.emit.${echeq?.cheque_tipo.toLowerCase()}.label`),
                    "string",
                ),
                getGeneralTicketItem(`${FORM_ID}.echeq.character`, echeq.cheque_caracter, "string"),
                getGeneralTicketItem(`${FORM_ID}.mode`, i18n.get(`echeqs.${echeq.cheque_modo}.modo`), "string"),
                getGeneralTicketItem(
                    `${FORM_ID}.concept`,
                    echeq.cheque_concepto.concat(" ", echeqConceptLabel(echeq.cheque_concepto, "-")),
                    "string",
                ),
                getGeneralTicketItem(`${FORM_ID}.motive`, echeq.cheque_motivo_pago, "string"),
                getGeneralTicketItem(`${FORM_ID}.coelsa.response`, transactionData.coelsaResponse, "string"),
                getGeneralTicketItem(`${FORM_ID}.coelsa.code`, transactionData.coelsaCode, "string"),
            ],
        };

        await exportGenericTicketPdfWithSuccessMessage(ticketData, dispatch, i18n.get("global.download.success"));

        this.setState({ fetchingDownload: false });
    };

    buttonsDetail = () => {
        const { dispatch, transactionData } = this.props;

        if (transactionData.idTransactionStatus !== "PENDING") {
            return [
                {
                    label: "global.goToHome",
                    bsStyle: "primary",
                    onClick: () => dispatch(push("/desktop")),
                },
            ];
        }
        return [];
    };

    render() {
        const { transactionData, isDesktop, isSmallDesktop, fetching, embeddedInV3Shell } = this.props;
        const { showDrawerMobile, fetchingDownload } = this.state;

        return (
            <>
                {transactionData?.idTransaction && (
                    <TransactionTicket
                        embeddedInV3Shell={embeddedInV3Shell}
                        embeddedV3GoBackPath="/echeqs"
                        embeddedV3LayoutScopes={["echeqs", "echeqsPending"]}
                        notificationScope="echeqs"
                        handleClick={this.exportPdf}
                        handleClickMessage="global.download"
                        emptyRightOption={
                            (isDesktop && transactionData?.idTransactionStatus !== "FINISHED") ||
                            (!isDesktop &&
                                transactionData?.idTransactionStatus !== "PENDING" &&
                                transactionData?.idTransactionStatus !== "FINISHED")
                        }
                        uniqueDownload={transactionData?.idTransactionStatus === "FINISHED"}
                        rightContent={
                            transactionData?.idTransactionStatus === "PENDING" && this.rightContentTransactionScheme
                        }
                        downloadImageWhite={!isDesktop}
                        headerClassName={!isDesktop ? "blue-main-header-mobile blue-main-title-mobile" : ""}
                        centerElement={isDesktop ? undefined : this.centerContentMobile}
                        hasInlineButtons
                        hideMobileMenu={!isDesktop}
                        isFetchingExport={fetchingDownload}
                        fetching={fetching}
                        summary={transactionData}
                        buttonsDetail={this.buttonsDetail()}
                        isDesktop={isDesktop}
                        isSmallDesktop={isSmallDesktop}
                        summaryTitle={`activities.${transactionData.idActivity}`}
                        showDrawerMobile={showDrawerMobile}
                        onSignTicket={this.signTransaction}
                        ignoreHomeButton
                        closeMobileDrawer={() => this.setState({ showDrawerMobile: false })}>
                        <EcheqAcceptReturnTransactionData />
                    </TransactionTicket>
                )}
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    transactionData: selectors.getTransactionEcheqData(state),
    fetching: selectors.getFetching(state),
});

export default connect(mapStateToProps)(EcheqTransaction);
